var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "lang-select" },
    [
      _c(
        "el-dropdown",
        {
          staticClass: "international",
          attrs: { trigger: "click" },
          on: { command: _vm.handleSetTimeZone },
        },
        [
          _c(
            "div",
            [
              _c("span", { staticClass: "lang-text" }, [
                _vm._v(_vm._s(_vm.timeZone) + ":00"),
              ]),
              _c("svg-icon", {
                attrs: {
                  "class-name": "time-zone-icon",
                  "icon-class": "time_zone",
                },
              }),
              _c("i", { staticClass: "el-icon-arrow-down icon-arrow-down" }),
            ],
            1
          ),
          _c(
            "el-dropdown-menu",
            {
              staticStyle: { padding: "0" },
              attrs: { slot: "dropdown" },
              slot: "dropdown",
            },
            [
              _c(
                "div",
                { staticClass: "time-zone-list" },
                _vm._l(_vm.timeZoneList, function (item, index) {
                  return _c(
                    "el-dropdown-item",
                    {
                      key: index,
                      attrs: { disabled: item === _vm.timeZone, command: item },
                    },
                    [_vm._v(" " + _vm._s(item) + ":00 ")]
                  )
                }),
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }